import React from "react";
import styled from "styled-components";

const AccessibilityContainer = styled.div`
  display: flex;
  margin-left: 10px;
`;

export function Accessibility(props) {
  return (
    <AccessibilityContainer>
      {/*<DonateButton>Donate</DonateButton>
      <VolunteerButton>Volunteer</VolunteerButton>*/}
    </AccessibilityContainer>
  );
}